module.exports = __webpack_public_path__ + "static/media/CircleNotification.0ed95b59.svg";